import { createApp } from 'vue'
import App from './App.vue'
import './styles/tailwind.css'; 

// Option 1 - Static import (works)
import * as cv from 'opencv.js' // Learning from https://github.com/greenpdx/opencv-vue
// Option 2 - dynamic import (does not work)
// import('opencv.js').then(cv => {
//     // Message module is available here...
//     app.config.globalProperties.cv = cv
// });

// Original
//createApp(App).mount('#app')

// With OpenCV
let app = createApp(App)
// 2. Assign the global variable before mounting
app.config.globalProperties.cv = cv
// 3. Use router and mount app
app.mount('#app')


